import React from "react";
import StageComponent from "./components/StageComponent/StageComponent";
import AddButtonComponent from "../../components/AddButtonComponent/AddButtonComponent";
import { useDispatch } from "react-redux";
import { addStage, addUserActionToStage } from "../../store/coreSlice";

export default function Stages({ goalId, stageIds }) {
  const dispatch = useDispatch();

  const handleAddStageClick = (index) => {
    dispatch(
      addStage({
        goalId,
        appendAfterIndex: index,
      })
    );
  };

  const handleAddUserActionClick = (stageId, index) => {
    dispatch(addUserActionToStage({ stageId, appendAfterIndex: index }));
  };

  return (
    <>
      {stageIds &&
        stageIds.map((d, index) => (
          <StageComponent
            key={d}
            stageId={d}
            index={index}
            goalId={goalId}
            handleAddUserActionClick={handleAddUserActionClick}
            handleAddStage={handleAddStageClick}
          />
        ))}
      <section style={{ height: "12rem" }}>
        <AddButtonComponent
          title="Add User Actions"
          handleAddButtonClick={handleAddStageClick.bind(this, -1)}
        />
      </section>
    </>
  );
}
